module.exports = __webpack_public_path__ + "./fonts/Logo-Conversation-Studio-login.svg";